var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.$store.state.mediaPhone)?_c('div',{attrs:{"id":"nav"}},[_c('header-bar')],1):_vm._e(),_c('router-view'),(!_vm.$store.state.mediaPhone)?_c('bottom-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }